export const DIRECT_DEBIT_ERROR_SHOW = 'DIRECT_DEBIT_ERROR_SHOW';
export const APPROVAL_POPUP_CLOSE = 'APPROVAL_POPUP_CLOSE';
export const APPROVAL_POPUP_SHOW = 'APPROVAL_POPUP_SHOW';
